import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { IDocumentRepository } from '@/modules/documents/domain/repositories/document.repository';

export namespace DownloadDocument {
  export type Input = IDocumentRepository.DownloadInput;
  export type Output = IDocumentRepository.DownloadOutput;

  export function useMutation() {
    const { repositories } = useDependencies();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn: (input) => repositories.document.download(input),
    });
  }
}
